import styled from '@emotion/styled'
import * as RadixAvatar from '@radix-ui/react-avatar'
import { DESIGN_TOKENS } from 'constants/color.constants'
import { pxToRem } from 'utils/rem.utils'

const AVATAR_SIZES = {
    lg: pxToRem(64),
    base: pxToRem(40),
    sm: pxToRem(32),
    xs: pxToRem(20),
}

export const StyledAvatar = styled(RadixAvatar.Root)<{
    size?: 'lg' | 'base' | 'sm' | 'xs'
}>`
    min-width: ${({ size }) => AVATAR_SIZES[size || 'base']};
    width: ${({ size }) => AVATAR_SIZES[size || 'base']};
    height: ${({ size }) => AVATAR_SIZES[size || 'base']};
    border-radius: 50%;
    background-color: ${DESIGN_TOKENS.background.secondary};
    display: flex;
    align-items: center;
    justify-content: center;
`
